import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
interface WhatsAppFloatProps {
  language: 'en' | 'es';
}
export function WhatsAppFloat({
  language
}: WhatsAppFloatProps) {
  const message = language === 'en' ? 'Hello, I would like to apply for business funding.' : 'Hola, quiero aplicar para financiamiento de negocios.';
  const handleClick = () => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'Contact');
    }
  };
  return <a href={`https://wa.me/13058138377?text=${encodeURIComponent(message)}`} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] text-white rounded-full shadow-2xl flex items-center justify-center hover:bg-[#20BA5A] transition-all hover:scale-110 animate-pulse" aria-label="Chat on WhatsApp" data-id="element-374">
      <MessageCircle size={32} data-id="element-375" />
    </a>;
}